import React, { useState } from "react";
import { Collapse, Empty, Space } from "antd";
import CommonImage from "@/components/common/image/CommonImage";
import { FaPlay } from "react-icons/fa";

export default function Syllabus({ course }) {
  const { Panel } = Collapse;

  const [activeSubjectKey, setActiveSubjectKey] = useState(
    course?.subjects?.[0]?.id
  );

  const renderCourseSyllabus = () => (
    <Space direction="vertical" size={16} className="syllabus_accordions">
      {course?.subjects?.map((subject) => (
        <Collapse
          accordion
          key={subject.id}
          style={{ width: "100%" }}
          items={[
            {
              key: String(subject.id),
              label: (
                <span className="syllabus-label">
                  <CommonImage
                    src={"/images/course-img/bangla.avif"}
                    alt="Syllabus Icon"
                    className="syllabus-icon"
                  />
                  {subject.title}
                </span>
              ),
              children:
                subject.modules?.length > 0 ? (
                  subject.modules.map((module, modIndex) => (
                    <Collapse
                      key={module.id}
                      collapsible="header"
                      defaultActiveKey={
                        modIndex === 0 ? [String(module.id)] : undefined
                      }
                      style={{ marginBottom: 16 }}
                      items={[
                        {
                          key: String(module.id),
                          label: (
                            <span className="syllabus-label">
                              <CommonImage
                                src={
                                  module.icon_url ??
                                  "/images/course-img/bangla.avif"
                                }
                                alt="Syllabus Icon"
                                className="syllabus-icon"
                              />
                              {module.title}
                            </span>
                          ),
                          children:
                            module.materials?.length > 0 ? (
                              module.materials.map((item, index) => (
                                <div
                                  className={"course_module_item_wrap"}
                                  key={index}
                                >
                                  <div className="title-area">
                                    <FaPlay className="icon" />
                                    <span className="course_module_title">
                                      {item.title}
                                    </span>
                                  </div>
                                  <div className="lock_unlock">
                                    <CommonImage
                                      src={`/images/course-img/${
                                        item.unlock ? "unlock.avif" : "lock.avif"
                                      }`}
                                      alt="Lock Icon"
                                      className={"icon block [.dark_&]:hidden"}
                                    />
                                    <CommonImage
                                      src={`/images/course-img/${
                                        item.unlock
                                          ? "d-unlock.avif"
                                          : "d-lock.avif"
                                      }`}
                                      alt="Lock Icon"
                                      className={"icon hidden [.dark_&]:block"}
                                    />
                                  </div>
                                </div>
                              ))
                            ) : (
                              <Empty />
                            ),
                        },
                      ]}
                    />
                  ))
                ) : (
                  <Empty
                    description={`No modules found for ${subject?.title}`}
                  />
                ),
            },
          ]}
        />
      ))}
    </Space>
  );

  return (
    <div className="syllabus_section">
      <h2 className="title">কোর্স সিলেবাস</h2>
      {course?.subjects?.length > 0 ? renderCourseSyllabus() : <Empty />}
    </div>
  );
}
